import type { FaireProductEntity } from "../../entity_types/product";

export const p_mw73mrzdn9: FaireProductEntity = {
  token: "p_mw73mrzdn9",
  type: "product",
  name: "Aloha | Car Diffuser",
  brandName: "Sunshine + Saltwater",
  imageUrl:
    "https://cdn.faire.com/fastly/f22b836fceb22f41fe30034187e84272dc3656963b9c29e8d8d91782d04bdf95.jpeg",
  priceDollars: 8.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/64b08d68f2b515da39483e68aa5a1a75546911df3156f1edf6f1d8d7ee72d5e8.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
